import styled from "styled-components";

export const HelpText = styled.span`
    position: absolute;
    left: 10px;
    transition: transform 0.2s, color 0.2s, font-size 0.2s;
    pointer-events: none;
    letter-spacing: 0.5px;
    color: ${(props) => props.theme.colors.tertiary[700]};
    ${(props) =>
        props.smallHelpText
            ? "font-size: 9px; transform: translateY(10px); text-transform: uppercase; top: -5px;"
            : "font-size: 15px; transform: translateY(5px); top: 5px;"}
`;
